import script from "./ReaderMode.vue?vue&type=script&setup=true&lang=js"
export * from "./ReaderMode.vue?vue&type=script&setup=true&lang=js"

import "./ReaderMode.vue?vue&type=style&index=0&id=a5200880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5200880"]])

export default __exports__